import { render, staticRenderFns } from "./OgcCatalogSection.vue?vue&type=template&id=6df21858&"
import script from "./OgcCatalogSection.vue?vue&type=script&lang=js&"
export * from "./OgcCatalogSection.vue?vue&type=script&lang=js&"
import style0 from "./OgcCatalogSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports